import React from 'react';

import type {} from '@mui/lab/themeAugmentation';
import { CircularProgress, lighten, ThemeOptions } from '@mui/material';

import { circularProgressSizeProps } from '../../../utils';

export const MuiLoadingButton: ThemeOptions['components']['MuiLoadingButton'] = {
  defaultProps: {
    loadingIndicator: (
      <CircularProgress
        color="inherit"
        size={circularProgressSizeProps.extraSmall.size}
        thickness={circularProgressSizeProps.extraSmall.thickness}
        disableShrink={true}
      />
    )
  },
  styleOverrides: {
    loadingIndicatorCenter: ({ theme, ownerState }) => ({
      color: theme.palette.common.white,
      ...(ownerState.variant === 'outlined' && {
        color: lighten(theme.palette.primaryShadowed.main, 0.4)
      })
    })
  }
};
